import { render, staticRenderFns } from "./visita.vue?vue&type=template&id=116eae52&"
import script from "./visita.vue?vue&type=script&lang=js&"
export * from "./visita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports